/* Decorative, compressed sequence. Copy and stage timings remain readable without JS. */
(() => {
  if (window.breziBrewMotion) { window.breziBrewMotion.init(document); return; }
  const instances = new Map();
  function init(scope) {
    scope.querySelectorAll('[data-brezi-brew-story]').forEach(root => {
      if (instances.has(root)) return;
      const button = root.querySelector('[data-brew-replay]');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      button.hidden = reduce.matches;
      let played = false, observer;
      function label(text) {
        button.textContent = text;
        button.setAttribute('aria-label', text.replace(' ↻', '') + ' — hot-to-cold brewing animation');
      }
      function finish() {
        root.removeAttribute('data-playing');
        root.removeAttribute('data-paused');
        root.setAttribute('data-finished', '');
        label('Replay sequence ↻');
      }
      function play() {
        played = true;
        root.removeAttribute('data-finished');
        root.removeAttribute('data-playing');
        root.removeAttribute('data-paused');
        if (reduce.matches) { finish(); return; }
        void root.offsetWidth;
        root.setAttribute('data-playing', '');
        label('Pause sequence');
      }
      function click() {
        if (!root.hasAttribute('data-playing')) { play(); return; }
        const paused = root.toggleAttribute('data-paused');
        label(paused ? 'Resume sequence' : 'Pause sequence');
      }
      function end(event) { if (event.animationName === 'bzb-cold-bar') finish(); }
      function motionChange() { button.hidden = reduce.matches; if (reduce.matches) finish(); }
      function visibility() {
        if (!root.hasAttribute('data-playing')) return;
        if (document.hidden) { root.setAttribute('data-paused', ''); label('Resume sequence'); }
      }
      button.addEventListener('click', click);
      root.addEventListener('animationend', end);
      reduce.addEventListener('change', motionChange);
      document.addEventListener('visibilitychange', visibility);
      if (reduce.matches) finish();
      else if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting && !played) play();
            else if (!entry.isIntersecting && root.hasAttribute('data-playing')) {
              root.setAttribute('data-paused', ''); label('Resume sequence');
            }
          });
        }, {threshold: .25});
        observer.observe(root.querySelector('.bzb-process'));
      } else finish();
      instances.set(root, () => {
        observer?.disconnect(); button.removeEventListener('click', click);
        root.removeEventListener('animationend', end); reduce.removeEventListener('change', motionChange);
        document.removeEventListener('visibilitychange', visibility); instances.delete(root);
      });
    });
  }
  window.breziBrewMotion = {init};
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-brezi-brew-story]').forEach(root => instances.get(root)?.());
  });
  init(document);
})();
